__turbopack_context__.v({
  "className": "manrope_c30ddfc5-module__zp_PUG__className",
  "variable": "manrope_c30ddfc5-module__zp_PUG__variable",
});
